// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__nMbok","ant-page-header-heading-title":"styles_ant-page-header-heading-title__6Wh1o","table":"styles_table__h3+Wx"};